import { computed } from 'vue'
import { FieldableFormCustomFieldFragment } from '@/components/Fieldable/graphql/fragments'
import { FragmentType, useFragment } from '@/gql'
import { isCustomFieldRequired } from '@/components/Fields/utils/CustomFieldUtils'

export default function useIsRequiredField(field: FragmentType<typeof FieldableFormCustomFieldFragment>) {
  const fieldTyped = computed(() => useFragment(FieldableFormCustomFieldFragment, field))
  return computed(() => isCustomFieldRequired(fieldTyped.value.settings))
}


